module.exports = __webpack_public_path__ + "static/number-3-e8427a501d6ffef90a43fde02e42ac78.webp";